import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Truck, Store, Loader2, CalendarDays } from "lucide-react";
import api from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";

const prettyDay = (iso) =>
  new Date(iso + "T00:00:00").toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
const isToday = (iso) => iso === new Date().toISOString().slice(0, 10);
const isPast = (iso) => iso < new Date().toISOString().slice(0, 10);

export default function CalendarView() {
  const navigate = useNavigate();
  const [days, setDays] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/calendar").then((r) => { setDays(r.data); setLoading(false); });
  }, []);

  if (loading)
    return <div className="flex justify-center pt-24"><Loader2 className="w-7 h-7 animate-spin text-[#581825]" /></div>;

  const upcoming = days.filter((d) => !isPast(d.date));

  return (
    <div className="px-4 pt-6">
      <h1 className="font-serif text-3xl font-bold text-[#581825] mb-1">Calendrier</h1>
      <p className="text-sm text-[#6E675F] mb-5">Retraits et livraisons prévus</p>

      {upcoming.length === 0 ? (
        <p className="text-center text-[#6E675F] pt-16">Aucune échéance à venir.</p>
      ) : (
        <div className="space-y-5">
          {upcoming.map((d) => (
            <div key={d.date}>
              <div className={`flex items-center gap-2 mb-2 ${isToday(d.date) ? "text-[#581825]" : "text-[#110F0F]"}`}>
                <CalendarDays className="w-4 h-4" />
                <h2 className="font-serif text-lg font-semibold capitalize">{prettyDay(d.date)}</h2>
                {isToday(d.date) && <span className="rounded-full bg-[#C5A059] text-[#110F0F] text-xs font-bold px-2 py-0.5">Aujourd'hui</span>}
              </div>
              <div className="bg-white rounded-2xl border border-[#E5DEC9] divide-y divide-[#F5EFEB]">
                {d.items.map((i) => (
                  <button key={i.orderId} onClick={() => navigate(`/admin/clients/${i.subscriptionId}`)}
                    className="w-full flex items-center gap-3 p-3 text-left hover:bg-[#F5EFEB]">
                    {i.deliveryMethod === "livraison"
                      ? <Truck className="w-4 h-4 text-blue-600" />
                      : <Store className="w-4 h-4 text-purple-600" />}
                    <div className="flex-1 min-w-0">
                      <p className="font-semibold text-[#110F0F] truncate">{i.name}</p>
                      <p className="text-xs text-[#6E675F]">
                        {i.planLabel} · {i.deliveryMethod === "livraison" ? "Livraison" : "Retrait magasin"}
                      </p>
                    </div>
                    <StatusBadge type="prep" value={i.preparationStatus} />
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
